import { cn } from '@cockpit/ui';
import type { ReactNode } from 'react';

export function Section({
  title,
  aside,
  children,
}: {
  title: string;
  aside?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-2.5 rounded-md border border-line-soft bg-surface p-4">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="font-display text-[15.5px] font-bold text-ink">{title}</h3>
        {aside && <span className="text-[12.5px] text-ink-3">{aside}</span>}
      </div>
      {children}
    </section>
  );
}

export function Stat({
  label,
  value,
  sub,
  bad,
}: {
  label: string;
  value: string;
  sub: string;
  bad?: boolean;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-0.5 bg-surface px-3.5 py-3">
      <dt className="text-[11px] font-semibold uppercase tracking-[0.07em] text-ink-3">{label}</dt>
      <dd
        className={cn(
          'tnum font-display text-[20px] font-bold leading-tight',
          bad ? 'text-danger-700' : 'text-ink',
        )}
      >
        {value}
      </dd>
      <dd className="text-[12.5px] text-ink-3">{sub}</dd>
    </div>
  );
}
